module.exports = __webpack_public_path__ + "img/banner-tc3-m.a4439a5a.jpg";